let userChannel = null
let lastRefreshedApiTokenAt = null

export default class {
    static start() {
        this.refreshApiTokenEveryFewMinutes()
    }

    static authId() {
        return Spark.userId
    }

    static authUser() {
        return Spark.state.user
    }

    static channel() {
        return userChannel ? userChannel : (userChannel = Echo.private('users.' + this.authId()))
    }

    static listen(event, handle) {
        this.channel().listen(event, handle)

        return {
            unsubscribe() {
                userChannel.stopListening(event)
            },
        }
    }

    static refreshApiTokenEveryFewMinutes() {
        lastRefreshedApiTokenAt = moment()

        setInterval(this.refreshApiToken, 240000)
        setInterval(() => {
            if (moment().diff(lastRefreshedApiTokenAt, 'minutes') >= 5) {
                this.refreshApiToken()
            }
        }, 5000)
    }

    static refreshApiToken() {
        lastRefreshedApiTokenAt = moment()

        axios.put('/spark/token')
    }

    static whenConnected(callback) {
        this.channel().subscription.subscribed
            ? callback()
            : this.channel().on('pusher:subscription_succeeded', () => callback())
    }
}
